(function () {
  if (window.groverCartRecommendationsLoaded) return;
  window.groverCartRecommendationsLoaded = true;

  var containers = Array.prototype.slice.call(document.querySelectorAll('[data-cart-recommendations]'));
  if (!containers.length) return;
  var root = containers[0].getAttribute('data-root') || '/';
  var generation = 0;
  var timer;

  function request(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Recommendation request failed');
      return response.json();
    });
  }

  function currency(price, code) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency', currency: code || 'CAD'
      }).format(price / 100);
    } catch (error) {
      return '$' + (price / 100).toFixed(2);
    }
  }

  function card(product, code) {
    var link = document.createElement('a');
    link.className = 'cart-recommendations__item';
    link.href = product.url;
    if (product.featured_image) {
      var img = document.createElement('img');
      img.src = product.featured_image;
      img.alt = product.title || '';
      img.loading = 'lazy';
      link.appendChild(img);
    }
    var title = document.createElement('span');
    title.className = 'cart-recommendations__item-title';
    title.textContent = product.title;
    link.appendChild(title);
    var price = document.createElement('span');
    price.className = 'cart-recommendations__item-price';
    price.textContent = currency(product.price, code);
    link.appendChild(price);
    return link;
  }

  async function update() {
    var current = ++generation;
    try {
      var cart = await request(root + 'cart.js');
      if (current !== generation) return;
      var cartIds = new Set(cart.items.map(function (item) { return item.product_id; }));
      var seen = new Set(cartIds);
      var chosen = [];
      var productIds = Array.from(cartIds).slice(0, 5);
      for (var i = 0; i < 2 && chosen.length < 4; i++) {
        var intent = i === 0 ? 'complementary' : 'related';
        for (var j = 0; j < productIds.length && chosen.length < 4; j++) {
          var url = root + 'recommendations/products.json?product_id=' + encodeURIComponent(productIds[j]) + '&limit=10&intent=' + intent;
          try {
            var response = await request(url);
            if (current !== generation) return;
            (response.products || []).forEach(function (product) {
              if (chosen.length < 4 && !seen.has(product.id)) {
                seen.add(product.id);
                chosen.push(product);
              }
            });
          } catch (error) {}
        }
      }
      if (current !== generation) return;
      containers.forEach(function (container) {
        var grid = container.querySelector('[data-cart-recommendations-grid]');
        grid.replaceChildren.apply(grid, chosen.map(function (product) { return card(product, cart.currency); }));
        container.hidden = chosen.length === 0;
      });
    } catch (error) {
      if (current !== generation) return;
      containers.forEach(function (container) { container.hidden = true; });
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 300);
  }

  document.querySelectorAll('[data-products]').forEach(function (element) {
    new MutationObserver(schedule).observe(element, { childList: true, subtree: true, characterData: true });
  });
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:build', schedule);
  schedule();
})();
